import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    path: [],
}

const fileBreadcrumbSlice = createSlice({
    initialState,
    name: "fileBreadcrumb",
    reducers: {
        set_path: (state, action) => {
            state.path = action.payload
        },
        // Enter Folder Dir Breadcrum
        enter_to_directory: (state, action) => {
            state.path = [...state.path, action.payload]
        },
    }
})

export default fileBreadcrumbSlice.reducer;

export const {
    enter_to_directory,
    set_path,
} = fileBreadcrumbSlice.actions;
